module.exports = __webpack_public_path__ + "img/mobile-phone.781a469d.png";